/*

	メーカー選択

*/
import * as React from "react"
import { useForm } from "react-hook-form"
import { ExtractionForm } from "@review/pages/Review/type"
import SelectListBox from "@review/components/SelectListBox"
import { gql, useQuery } from "urql"

export default function SelectMaker(props: {
  name: string
  label: string
  intage_generic_category_lv3name: string[]
  jicfs_lv4name: string[]
  sub_category: string[]
}) {
  const filter = {
    intage_generic_category_lv3name: props.intage_generic_category_lv3name,
    jicfs_lv4name: props.jicfs_lv4name,
    subcategory_name: props.sub_category,
  }

  const [result] = useQuery({
    query: /* GraphQL */ `
      query getMakerOptions($MakerFilterInput: MakerFilterInput) {
        getMakerOptions(filter: $MakerFilterInput)
      }
    `,
    variables: {
      MakerFilterInput: filter
    },
  })

  const getOptionsFromResult = () => {
    if (result.fetching || result.error) return []
    if (result.data.getMakerOptions == null) return []
    return result.data.getMakerOptions
  }

  const getOptions = () => {
    return result.fetching
      ? []
      : getOptionsFromResult()
  }

  return(
    <SelectListBox
      name={props.name}
      label={props.label}
      items={getOptions()}
    />
  )
}
